function withDataAttrFallback(attrs) {
  return Object.entries(attrs).reduce(
    (acc, [key, value]) => {
      if (key.startsWith("data") && key.length > 4) {
        const primaryKey = key.charAt(4).toLowerCase() + key.slice(5);
        if (!(primaryKey in attrs)) acc[primaryKey] = value;
      }
      return acc;
    },
    { ...attrs }
  );
}
export {
  withDataAttrFallback
};
//# sourceMappingURL=attributes-with-data-fallback.js.map
